export default {
    brand_name: '云生涯'
}